module.exports = __webpack_public_path__ + "static/media/hm.d13f9cb3.svg";